import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("分享您的設計圖")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 分享至Facebook ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 分享至WhatsApp ")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 儲存圖片 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 你可隨時透過以下連結進入你的設計 ")
const _hoisted_8 = { style: {"letter-spacing":"normal"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("複製")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { class: "ion-text-start" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-text-center",
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              class: "ion-margin-top",
              shape: "round",
              fill: "outline",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareToFacebook()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.logoFacebook
                }, null, 8, ["icon"]),
                _hoisted_2
              ]),
              _: 1
            }),
            _hoisted_3,
            _createVNode(_component_ion_button, {
              shape: "round",
              fill: "outline",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shareToWhatsApp()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.logoWhatsapp
                }, null, 8, ["icon"]),
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("p", null, [
              _createElementVNode("img", { src: _ctx.designDataURL }, null, 8, _hoisted_5)
            ]),
            _createVNode(_component_ion_button, {
              shape: "round",
              fill: "outline",
              href: _ctx.designDataURL,
              target: "_blank",
              download: `${_ctx.designName || 'design'}.png`
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_ion_icon, {
                  slot: "end",
                  icon: _ctx.downloadOutline
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["href", "download"]),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, { class: "ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      fill: "outline",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap ion-text-center" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_8, "d.crystalputeri.com/" + _toDisplayString(_ctx.designId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyDesignLink()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}